"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8613,4985],{

/***/ 8613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ asg_info_bar_list_AsgInfoBarList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/widgets/asg-info-bar/index.tsx + 1 modules
var asg_info_bar = __webpack_require__(4985);
;// CONCATENATED MODULE: ./components/widgets/asg-info-bar-list/AsgInfoBarList.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AsgInfoBarList = function(param) {
    var _data = param.data, data = _data === void 0 ? [] : _data;
    var ref = (0,react.useState)(null), sortedData1 = ref[0], setSortedData = ref[1];
    (0,react.useEffect)(function() {
        var sortDataByTitle = function() {
            var sortedData = data.sort(function(a, b) {
                return a.title.localeCompare(b.title);
            });
            return sortedData;
        };
        var sortedData2 = sortDataByTitle();
        setSortedData(sortedData2);
    }, [
        data
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: sortedData1 && sortedData1.map(function(item, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(asg_info_bar["default"], _objectSpread({}, item, {
                isReverse: index % 2 !== 0
            }), index);
        })
    }));
};
/* harmony default export */ var asg_info_bar_list_AsgInfoBarList = (AsgInfoBarList);

;// CONCATENATED MODULE: ./components/widgets/asg-info-bar-list/index.tsx



/***/ }),

/***/ 4985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ asg_info_bar_AsgInfoBar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/base/image/index.tsx + 1 modules
var base_image = __webpack_require__(5244);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 6 modules
var gridview = __webpack_require__(8117);
// EXTERNAL MODULE: ./core/hooks/useWidthResize.ts
var useWidthResize = __webpack_require__(4546);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./components/base/anchor/Anchor.tsx
var Anchor = __webpack_require__(3357);
;// CONCATENATED MODULE: ./components/widgets/asg-info-bar/AsgInfoBar.tsx







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AsgInfoBar = function(props) {
    var width = (0,useWidthResize/* useWidth */.z)();
    var app = (0,contexts_app/* useApp */.qD)();
    var TextContent = function() {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Column */.sg, {
            xs: {
                size: 12,
                order: 'first'
            },
            sm: {
                size: 12,
                order: 'first'
            },
            xl: {
                size: 8,
                order: props.isReverse ? 'last' : 'first'
            },
            className: "left",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        textAlign: props.isReverse ? 'right' : 'left'
                    },
                    className: "group-title",
                    children: props.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    style: {
                        textAlign: props.isReverse ? 'right' : 'left'
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: props.description
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, _objectSpread({}, props.link, {
                    className: "button",
                    children: app.settings.translations['read-more']
                }))
            ]
        }));
    };
    var ImageContent = function() {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
            xs: {
                size: 12,
                order: 'last'
            },
            sm: {
                size: 12,
                order: 'last'
            },
            xl: {
                size: 4,
                order: props.isReverse ? 'first' : 'last',
                align: 'center'
            },
            className: "right",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, _objectSpread({}, props.link, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_image["default"], _objectSpread({
                    alt: ""
                }, props.image))
            }))
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
            className: "info-bar-wrapper ".concat(props.isReverse && 'reverse'),
            gutter: "md",
            id: props.title,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContent, {})
                ]
            })
        })
    }));
};
/* harmony default export */ var asg_info_bar_AsgInfoBar = (AsgInfoBar);

;// CONCATENATED MODULE: ./components/widgets/asg-info-bar/index.tsx



/***/ })

}]);